import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips, heroPillars } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-64" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-4xl px-5 pb-6 text-center" style={{
      paddingBottom: "14px"
    }} data-id="element-65" data-mp="9lbg511q9bdl">
        <h1 className="mx-auto max-w-2xl pt-2 font-display text-[25px] font-black uppercase leading-tight text-plum sm:text-[38px]" style={{
        paddingTop: "11px",
        marginTop: "-15px",
        marginBottom: "-15px"
      }} data-id="element-66" data-mp="4na0yr7f9w7e">
          Build <span className="text-grape" data-id="element-67" data-mp="xb5w3rhcfg22">better</span> freelance proposals in{' '}
          <span className="text-grape-shine" data-id="element-68" data-mp="s9q7jpfyirex">less time</span>
        </h1>

        <p className="mx-auto max-w-2xl pb-2.5 pt-4 font-display text-[11px] font-bold uppercase tracking-[0.18em] text-plum/60 sm:text-sm" data-id="element-69" data-mp="nczqozwbvrsg">
          The practical AI-powered system to organize client briefs, define project scope, and create more professional proposals with confidence.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-70" data-mp="3j8977bv8e9p0">
          <img src="https://cdn.magicpatterns.com/uploads/tuA7Dnznnz3SgrkgxvcrhF/Kit_de_Propuestas_Freelance_Sigma_Smart_(1).webp" alt="The Freelance Proposal Machine™ — 6-volume system plus 5 professional bonuses" width={1536} height={1024} sizes="(min-width: 640px) 640px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[640px] object-contain" style={{
          paddingTop: "12px"
        }} data-id="element-71" data-mp="39cfm343g57vm" />
        </motion.div>

        
        
        <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-72" data-mp="2vjpy4u4cxsvv">
          6-Volume Visual System + 5 Professional Bonuses · ⚡ Instant Digital Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-73" data-mp="2ljpef72ktar5">
          <CTAButton href="#pricing" data-id="element-74" data-mp="s21kmih80q35">See the complete system now</CTAButton>

          <p className="mx-auto mt-6 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-75" data-mp="s44ifoom7nif">
            <span className="font-bold text-plum" data-id="element-76" data-mp="na08cwk1yzd4">THE PRACTICAL AI PROPOSAL SYSTEM FOR 2026.</span>{' '}
            Designed for freelancers, consultants, designers, developers, copywriters, digital marketers, virtual
            assistants, and independent professionals who want to prepare clearer proposals and organize their client workflow.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-77" data-mp="161jcx7tq6lh9">{heroPillars}</h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-78" data-mp="111es55lsb4l8">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-plum/15 bg-white px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-79" data-mp="x37falufynfb">
                <Icon className="h-3.5 w-3.5 text-grape" aria-hidden="true" data-id="element-80" data-mp="3hpse948bhp1i" />
                {label}
              </span>)}
          </div>

          <p className="mx-auto mt-6 max-w-2xl text-sm font-semibold text-plum sm:text-base" data-id="element-81" data-mp="21awbi3eoahds">
            Everything you need to build a more repeatable proposal process—in one organized system.
          </p>
        </div>

        <div className="mt-6 inline-flex flex-col items-center gap-1 rounded-2xl bg-plum px-6 py-3 text-white shadow-[0_0_0_1px_rgba(46,197,255,0.45),0_12px_32px_-14px_rgba(0,112,255,0.7)]" data-id="element-82" data-mp="2b197crrxtwz8">
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-grape-soft" data-id="element-83" data-mp="2kynd9xg8j3da">🔥 Limited-time launch offer</span>
          <span className="font-display text-lg font-black" data-id="element-84" data-mp="2p1jzdy4zhhlz">
            <span className="mr-2 text-white/50 line-through" data-id="element-85" data-mp="2tzboyli5orn0">$54 USD</span>
            <span className="text-grape-soft" data-id="element-86" data-mp="2txhc7uh1g5u0">$27 USD</span>
          </span>
          <span className="text-xs font-semibold text-white/75" data-id="element-87" data-mp="uo0uu4cjcyr6">Save $27 USD — 50% OFF</span>
        </div>
      </div>
    </header>;
}